<template>
  <div class="user">
    <div class="header  bg-color-red">
      <div class="info-top acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="pictrue"><img :src="userInfo.avatar" /></div>
          <div class="text">
            <div class="acea-row row-middle">
              <div class="name line1">{{ userInfo.nickname }}</div>
              <div class="member acea-row row-middle" v-if="userInfo.vip">
                <!-- <img :src="userInfo.vip_icon" /> -->
                {{ userInfo.vip_name }}
              </div>
            </div>
            <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
              ID：{{ userInfo.uid || 0
              }}<span class="iconfont icon-bianji1"></span>
            </router-link>
            <router-link :to="'/user/binding'" class="binding" v-else>
              <span>绑定手机号</span>
            </router-link>
          </div>
        </div>
        <span 
          class="iconfont icon-shezhi"
          @click="$router.push({ path: '/user/data' })"
        ></span>        
      </div>
      <div class="info-foot">
        <div v-for="(item, index ) in infoList" :key="index" 
            class="info-item"
            @click="goView(item.path, item.state)">
          <div class="counter"> {{ item.count }} </div>
          <div class="info-text">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="bottom-radius"></div>
    </div>
    <div class="wrapper">
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的参与</div>
        </div>
         <div class="serviceList acea-row row-middle">
        <template>
          <div class="table">
            <div v-for="(item, index) in titleList" :key="index" 
                          @click="goView(item.path, item.state)" class="item">
              <div class="pictrue">
                <img :src="item.picUrl" />
              </div>
              <div class="item-name"> {{ item.name }} </div>
            </div>
          </div>
        </template>
       </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle" v-if="userInfo.adminid== true">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>

        </div>
      </div>
    </div>
    <!-- <img src="@assets/images/support.png" class="support" /> -->
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser, getUserStudent, getUserStudentLesson, getLeaveFormerly } from "@api/user";
import { notVisitCommentCount } from "@api/grade";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
import { getWeek } from '@common'

const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      studentUidList: [], //学生idList
      infoList: [
        { name: '剩余课时', count: 0, path: '/user/student/lesson/list', state: true }, 
        { name: '今日课程', count: 0, path: '/user/studentClassList', state: true },
        { name: '请假次数', count: 0, path: '/user/student/rest/list', state: true },
        { name: '未读点评', count: 0, path: '/grade/gradeWorkList', state: true },
      ],
      titleList: [
        { name: '订单', picUrl: require('@assets/images/user/myJion/order-icon.png'), path: '/order/list/0', state: false },
        { name: '课程今日表', picUrl: require('@assets/images/user/myJion/lesson-icon.png'), path: '/user/studentClassList', state: true },
        { name: '我的课程', picUrl: require('@assets/images/user/myJion/course-icon.png'), path: '/user/student/lesson/list', state: true },
        { name: '请假单', picUrl: require('@assets/images/user/myJion/evaluate-icon.png'), path: '/user/student/rest/list', state: true },
        { name: '作业展示', picUrl: require('@assets/images/user/myJion/production-icon.png'), path: '/user/workEvaluate', state: true },
        { name: '添加作品', picUrl: require('@assets/images/user/myJion/addwork-icon.png'), path: '/user/studentWork', state: true },
        { name: '当前积分', picUrl: require('@assets/images/user/myJion/evaluate-icon.png'), path: (/*/user/test*/'/user/test'), state: true },
      ],
      userSutdentInfoList: {},
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    /**
     * 页面跳转
     */
    goView(path, state) {
      if (path) {
        if (this.userInfo.uid && state) {
          this.$router.push(path+'/'+this.userInfo.uid);
        }else if (!state){
          this.$router.push(path);
        }
      }
    },
    getStudentLesson() { //获取用户学生信息
      getUserStudent(this.userInfo.uid).then(res => { 
        this.userSutdentInfoList = res.data;
        const hourList = res.data.studentProduct;
        if (!this.infoList[0].count) {
          for (let item of hourList) {
            for (let item_mix of item) {
              if (item_mix.classtime && item_mix.classtimes)
                 this.infoList[0].count += item_mix.classtime; //添加剩余课时
            }
          }
        }
        for (let item of res.data.student) {
          this.studentUidList.push(item.Id);
        }
        getUserStudentLesson({student_id: this.studentUidList}).then(res => {
          let resList = res.data.studentLesson;
          if (!this.infoList[1].count) {
            for (let item of resList) {
              for (let item_mix of item) {
                if (getWeek(Number(item_mix.start_time+'000')) === getWeek()) {
                  this.infoList[1].count += 1; //添加今日课程
                }
              }
            }
          }
        })
      })
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
        };

        this.getStudentLesson(); //获取学生信息
        getLeaveFormerly(this.userInfo.uid).then(res => {
          this.infoList[2].count = res.data.data.length;
        });
        notVisitCommentCount({ user_id: this.userInfo.uid}).then(res => {
          this.infoList[3].count = res.data.numbera;
        })
      })
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      if (url === "/user/workView") {
        if (this.userInfo.uid) {
          return this.$router.push({ path: url +'/'+ this.userInfo.uid });
        }
        return false;
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
      console.log(url);
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #2980f7;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #2980f7;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
.user .header {
  padding-top: 0.2rem;
  height: auto;
  position: relative;
  margin-bottom: 1.2rem;
}
.info-foot {
  height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 2;
}
.info-item {
  flex: 1;
  text-align: center;
}
.counter {
  font-size: 0.3rem;
}
.info-text {
  font-size: 0.25rem;
}
.bg-color-red{
  background-color:#2980f7!important;
  }
.table {
  padding: 0.2rem;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.item{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0.2rem 0;
  width: 25%;
}
.item-name{
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  width: 100%;
}
.item img {
  width: 0.4rem;
  height: 0.4rem;
}
.bottom-radius {
  width: 100vw;
  height: 1rem;
  position: absolute;
  left: 0;
  border-bottom-right-radius: 50%;
  border-bottom-left-radius: 50%;
  background-color: #2980f7;
  bottom: -0.5rem;
  z-index: 1;
}
</style>
